/**
 * Section Scroller Class
 * issue: https://rituals.atlassian.net/browse/DL-11122
 *
 * Allows for a section controlled scrolling for desktop
 */
'use strict';

const isMobileDevice = require('./modules/helpers/isMobileDevice');
const isTabletPortraitView = require('./modules/helpers/isTabletPortraitView');
const scrollToSectionEl = '.js-scrollto-section';

let isScrolling = false;

/**
 * Initializes the Intersection Observer and observe our scroll sections
 */
const initSectionScroller = () => {
    const observer = new IntersectionObserver((sections) => {
        for (const section of sections) {
            if (section.isIntersecting === true && section.intersectionRatio > 0.05 && !isScrolling) {
                scrollToSection(section.target);
            }
        }
    }, {
        threshold: 0.05
    });

    $(scrollToSectionEl).each(function(i, el) {
        observer.observe(el);
    });
};

/**
 * Scrolls to a give element
 *
 * @param {Element} el Element to scroll to
 */
const scrollToSection = (el) => {
    isScrolling = true;
    const scrollerSpeed = $('.advent-gradient').length > 0 ? 2500 : 600;

    $('html, body').stop().animate({
        scrollTop: $(el).offset().top
    }, scrollerSpeed, 'easeOutQuart', () => {
        isScrolling = false;
    });
};

const scrollToCustomizableSection = (el) => {
    isScrolling = true;
    const productImageHeight = $('.js-product-images').outerHeight();

    $('html, body').stop().animate({
        scrollTop: $(el).offset().top - productImageHeight
    }, 600, 'easeOutQuart', () => {
        isScrolling = false;
    });
};

const scrollWithOffset = (el) => {
    isScrolling = true;
    const headerOffset = $('.js-header').outerHeight();

    $('html, body').stop().animate({
        scrollTop: $(el).offset().top - headerOffset
    }, 600, 'easeOutQuart', () => {
        isScrolling = false;
    });
};

/**
 * Checks the elements on the page and the device to determine if we should init
 *
 * @returns {Boolean} We should init, true or false
 */
const shouldInit = () => {
    return supportsIntersectionOberver() &&
        $(scrollToSectionEl).length > 0 &&
        !isMobileDevice() &&
        !isTabletPortraitView();
};

/**
 * Checks if the IntersectionObserver is supported
 */
const supportsIntersectionOberver = () => {
    return 'IntersectionObserver' in window &&
        'IntersectionObserverEntry' in window &&
        'intersectionRatio' in window.IntersectionObserverEntry.prototype;
};

const sectionScroller = {
    init: () => {
        if (shouldInit()) {
            initSectionScroller();
        }
    },
    scrollTo: scrollToSection,
    scrollToCustom: scrollToCustomizableSection,
    scrollWithOffset: scrollWithOffset
};

module.exports = sectionScroller;
